import { Feature, Polygon, Position } from 'geojson';
import {
    FacilityAreaDto,
    FacilityAreaGeometryDto,
    GeoPointDto
} from '../../../core/api/StudioClient';
import { DrawingMode, FeatureArea } from './draw-controls';
import { AreaGeometryDto } from './store';

export const VISIT_AREA_COLOR = '#42a5f5';
export const CHECKIN_AREA_COLOR = '#66bb6a';

export function convertAreaToGeoPolygon(points: Position[]): GeoPointDto[] {
    return points.map(([longitude, latitude]) => ({
        longitude,
        latitude
    }));
}

interface FormDataDto {
    center: { latitude: number; longitude: number };
    visitArea?: AreaGeometryDto[];
    checkInArea?: AreaGeometryDto[];
}

export function convertFormDataToApi(formData: FormDataDto): FacilityAreaDto {
    return {
        center: {
            longitude: formData.center.longitude,
            latitude: formData.center.latitude
        },
        ...(formData.checkInArea && {
            checkInArea: convertAreaGeometryToFacilityAreaGeometry(
                formData.checkInArea
            )
        }),
        ...(formData.visitArea && {
            visitArea: convertAreaGeometryToFacilityAreaGeometry(
                formData.visitArea
            )
        })
    };
}

function convertAreaGeometryToFacilityAreaGeometry(
    areaGeometry: AreaGeometryDto[]
): FacilityAreaGeometryDto {
    return { polygons: areaGeometry.map((area) => ({ points: area.points })) };
}

export function convertFacilityAreaGeometryToFeatureCollection(
    areaGeometry: FacilityAreaGeometryDto,
    mode: DrawingMode
): Feature<Polygon>[] {
    return areaGeometry.polygons.map((area) => ({
        type: 'Feature',
        properties: {
            mode,
            portColor:
                mode === 'visit-area' ? VISIT_AREA_COLOR : CHECKIN_AREA_COLOR
        },
        geometry: {
            type: 'Polygon',
            coordinates: [
                area.points.map(({ longitude, latitude }) => [
                    longitude,
                    latitude
                ])
            ]
        }
    }));
}

export function convertFeatureAreaToAreaGeometryDto(feature: FeatureArea) {
    return {
        id: feature.id?.toString() || Date.now().toString(),
        points: convertAreaToGeoPolygon(feature.geometry.coordinates?.[0]) || []
    };
}
